'use client'
import { createContext, ReactNode, useContext, useMemo } from 'react'
import type { Building } from '../types/building'

type BuildingsContextValue = {
  buildings: Building[]
  /** For lists only: excludes inactive buildings */
  activeBuildings: Building[]
  /** Searches all buildings, including inactive ones */
  getBuildingByKey: (key: string) => Building | undefined
}

const createValue = (buildings: Building[]): BuildingsContextValue => ({
  buildings,
  activeBuildings: buildings.filter((b) => b.active),
  getBuildingByKey: (key) => buildings.find((b) => b.key === key),
})

const BuildingsContext = createContext<BuildingsContextValue | null>(null)

export const BuildingsProvider = ({ buildings, children }: { buildings: Building[]; children: ReactNode }) => {
  const value = useMemo(() => createValue(buildings), [buildings])
  return <BuildingsContext.Provider value={value}>{children}</BuildingsContext.Provider>
}

export const useBuildings = (): BuildingsContextValue => {
  const value = useContext(BuildingsContext)
  if (!value) throw new Error('useBuildings must be used within a BuildingsProvider')
  return value
}
